import { render } from "./TouchInterfacePlaying.vue?vue&type=template&id=036ec34f&scoped=true&ts=true"
import script from "./TouchInterfacePlaying.vue?vue&type=script&lang=ts"
export * from "./TouchInterfacePlaying.vue?vue&type=script&lang=ts"

import "./TouchInterfacePlaying.vue?vue&type=style&index=0&id=036ec34f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036ec34f"]])

export default __exports__